import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { StateService } from '@app/core/services/state.service';
import { UtilityService } from '@app/core/services/utility.service';
import type { GridMessage } from '../../grid.service';

@Component({
    selector: 'tt-grid-messages-modal',
    templateUrl: './grid-messages-modal.component.html',
    styleUrls: ['./grid-messages-modal.component.css'],
})
export class GridMessagesModalComponent {
    public readonly type: GridMessageModalType;
    public readonly title: string;
    public readonly messages: GridMessage[];
    public readonly showMessageTitles: boolean;

    constructor(
        public dialogRef: MatDialogRef<GridMessagesModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: GridMessagesModalData,
        private state: StateService,
        private utility: UtilityService,
    ) {
        this.messages = data.messages ?? [];
        this.type = data.type ?? this.messages[0]?.type ?? 'warning';
        this.title = data.title || this.messages.find((message) => !!message.title?.trim?.())?.title || ' ';
        this.showMessageTitles = new Set(this.messages.map((message) => message.title).filter((title) => !!title?.trim?.())).size > 1;
    }

    public get titleClass(): string {
        return `tt-${this.type}-background`;
    }

    public shouldShowTitle(message: GridMessage): boolean {
        return this.showMessageTitles && !!message.title?.trim?.();
    }

    public getStatePath(message: GridMessage): string {
        return message.item_state ? this.utility.generateStatePath(message.item_state, message.item_parms) : '';
    }

    public goto(message: GridMessage, event: MouseEvent): void {
        if (!message.item_state) return;

        event.preventDefault();
        this.dialogRef.close();

        if (this.utility.isModifierKeyPressed(event)) {
            this.state.newTab(message.item_state, message.item_parms);
        } else {
            this.state.go(message.item_state, message.item_parms);
        }
    }

    public trackByMessage(index: number, message: GridMessage): string {
        return message.id || `${message.keyno}-${index}`;
    }
}

export interface GridMessagesModalData {
    type: GridMessageModalType;
    title: string;
    messages: GridMessage[];
}

export type GridMessageModalType = 'primary' | 'success' | 'warning' | 'danger';
